import { useCallback } from 'react'

import { useNavigate } from '@/routing'

import { useController } from './useController'

export function useControllerActions() {
  const navigate = useNavigate(true)
  const { close, updateData } = useController()

  const navigateToTerritorySettings = useCallback(() => {
    navigate('territory')
    close?.()
  }, [navigate])

  const getStorageTips = useCallback(() => {
    updateData({ wizardStep: 'storage-tips' })
  }, [updateData])

  const onPrevButtonClick = useCallback(() => {
    updateData({ wizardStep: 'warning' })
  }, [updateData])

  return { navigateToTerritorySettings, getStorageTips, onPrevButtonClick }
}
